module.exports = __webpack_public_path__ + "media/images/logo/usps-72f6436cb7fa53d6571248ed6b5eaf04.gif";